const IframeService = {
  closeIframe: (closeMsg: string): void => {
    const objMessage = {
      type: 'PAYMENT_LANDING_PEPPER',
      message: closeMsg
    }
    window.parent?.postMessage(objMessage, "*");
  },
};

export default IframeService;